module.exports = __webpack_public_path__ + "static/media/application_5.5124ba81.png";